import { get, post } from "@/api";
import type { AuthUser } from "@/utils/auth";

export interface LoginParams {
  account: string;
  password: string;
}

export interface LoginResult {
  member: AuthUser;
  token: string;
}

export interface LoginResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
  data?: LoginResult;
  errors?: Record<string, string[]>;
}

export interface MemberResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
  /** 账号信息（含 is_canedit / is_divide） */
  data?: AuthUser;
  /** 当前待我审批节点的订单数量 */
  flows_count?: number;
  /** 当前待我审批节点的工作数量 */
  works_count?: number;
  /** 与 data 同步，便于直接读取 */
  is_divide?: boolean;
  is_canedit?: boolean;
}

/** 平台账号登录 */
export function login(params: LoginParams) {
  return post<LoginResponse>("/platform/auth/login", params);
}

/** 获取当前登录账号信息 */
export function getMember() {
  return get<MemberResponse>("/platform/auth/member");
}

export interface LogoutResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
}

/** 退出登录 */
export function logout() {
  return post<LogoutResponse>("/platform/auth/logout");
}

export interface AuthDepartmentPerson {
  id: number | string;
  account?: string;
  name: string;
  phone?: string;
}

export interface AuthDepartment {
  id: number | string;
  title: string;
  /** 科室下人员（代购下单联动） */
  persons?: AuthDepartmentPerson[];
}

export interface AuthDepartmentsResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
  data?: AuthDepartment[];
}

/** 当前账号可筛选的科室列表 */
export function getAuthDepartments() {
  return get<AuthDepartmentsResponse>("/platform/auth/departments");
}
